import { Store } from "@mui/icons-material";
import { Avatar, Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import AuthCard from "../../pages/auth/AuthCard";
import { IUser } from "../../stateManagement/reducers/authReducer";
import { ICustomer } from "../../stateManagement/reducers/customersReducer";
import Form from "./From";

interface IRequestOrderProps {
  customer?: ICustomer;
  user?: IUser;
  setOpened: (truth: boolean) => void;
}

const RequestOrder: React.FC<IRequestOrderProps> = ({
  customer,
  user,
  setOpened,
}) => {
  return (
    <AuthCard
      maxWidth={600}
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pl: "0 !important",
        pr: "0 !important",
        borderRadius: "0 !important",
        backgroundColor: "background.paper",
      }}
      noBoxPadding={true}
    >
      <Grid container sx={{ width: "100%" }}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            pr: "2rem",
            display: { xs: "none", md: "flex", position: "relative" },
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              height: "calc(100vh + .5rem)",
              width: "100%",
              backgroundColor: "primary.light",
              position: "relative",
              zIndex: "0",
              bottom: "1.75rem",
              "& img": {
                width: "100% !important",
                height: "100% !important",
                objectFit: "cover !important",
              },
              "&::after": {
                content: '""',
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                pointerEvents: "none", // Allows clicks/events to pass through
              },
            }}
            src="/images/waiting-room.png"
          >
            <Store
              sx={{
                width: "20rem",
                height: "20rem",
                color: "background.paper",
              }}
            />
          </Avatar>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          container
          spacing={3}
          alignItems="center"
          justifyContent="center"
          height={"100%"}
        >
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="baseline"
              sx={{ mb: { xs: -0.5, sm: 0.5 } }}
            >
              <Typography variant="h3" sx={{ color: "primary.main" }}>
                New Order
              </Typography>
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ height: "calc(100vh - 8rem)", overflowY: "auto", p: "1rem" }}
          >
            <Form
              customerId={
                user && user?.customerId
                  ? user.customerId
                  : customer
                    ? customer._id
                    : ""
              }
              setOpened={setOpened}
            />
          </Grid>
        </Grid>
      </Grid>
    </AuthCard>
  );
};

export default RequestOrder;
